<template>

  <div style="background-color: white;padding: 20px;margin-top: -16px;border-top: none">

    <ConfirmModal id="budgetItemRemove" ref="budgetItemRemove" :okButtonText="$t('message.delete')"
                  @ok-handle="deleteFromDatabase"></ConfirmModal>

    <div class="row dash-chart">
      <div class="col-xl-4 box-col-4 col-lg-12 col-md-4">
        <div class="card o-hidden">
          <div class="card-body">
            <div class="ecommerce-widgets media">
              <div class="ecommerce-box light-bg-primary mr-4">
                <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>
              </div>
              <div class="media-body">
                <p class="f-w-500 font-roboto">
                  <span v-if="'capital' != cat.name.toLowerCase()">{{ $t('message.budget_total') }}</span>
                  {{ $t('message.budget_' + cat.name) }}
                </p>
                <h4 class="f-w-500 mb-0 f-20">
                  $
                  <span class="counter"
                        v-if="total_expenses != null">{{ total_expenses == 0 ? '-' : total_expenses.toFixed(2) }}</span>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 box-col-4 col-lg-12 col-md-4">
        <div class="card o-hidden">
          <div class="card-body">
            <div class="ecommerce-widgets media">
              <div class="ecommerce-box light-bg-primary mr-4">
                <i class="fa fa-fire" aria-hidden="true"></i>
              </div>
              <div class="media-body">
                <p class="f-w-500 font-roboto">
                  {{
                    this.cat.name.toLowerCase() == 'expenses' ? $t('message.budget_inflation') : $t('message.budget_earn')
                  }}
                </p>
                <h4 class="f-w-500 mb-0 f-20">
                  <span class="counter">{{
                      this.cat.name.toLowerCase() == 'expenses' ? Math.round(budget.burn_rate * 12) : Math.round(budget.earn_rate * 12)
                    }}% ({{ $t('message.per_year') }})</span>
                </h4>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 box-col-4 col-lg-12 col-md-4">
        <div class="card o-hidden">
          <div class="card-body">
            <div class="ecommerce-widgets media">
              <div class="ecommerce-box light-bg-primary mr-4">
                <i class="fa fa-tasks" aria-hidden="true"></i>
              </div>
              <div class="media-body">
                <p class="f-w-500 font-roboto">
                  {{ $t('message.budget_break_even') }}
                </p>
                <h4 class="f-w-500 mb-0 f-20">
                  {{ break_even }}
                </h4>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="steps && steps.length" class="mb-1">
      <h6>{{ $t('message.budget_related_steps') }}</h6>
      <button type="button" class="btn btn-sm btn-primary mr-1 mb-2"
              v-for="step in steps" :key="step.id">
        {{ step.translation['en'].name }}
      </button>
    </div>
    <div class="row text-right mb-2">

      <div class="col-0 col-lg-8"></div>
      <div class="col-6 col-lg-2">
        <b-select size="width:100px" v-model="displayType">
          <b-form-select-option value="bar">{{ $t('message.budget_bar_chart') }}</b-form-select-option>
          <b-form-select-option value="pie">{{ $t('message.budget_pie_chart') }}</b-form-select-option>
        </b-select>
      </div>
      <div class="col-6 col-lg-2" v-if="displayType != 'pie'">
        <b-select size="width:100px" v-model="displaySelected"
                  @change="chageChartData()">
          <b-form-select-option value="lines">{{ $t('message.budget_separate') }}</b-form-select-option>
          <b-form-select-option value="stacked">{{ $t('message.budget_stacked') }}</b-form-select-option>
          <!--          <b-form-select-option value="sum">Sum</b-form-select-option>-->
        </b-select>
      </div>

      <div class="col-6 col-lg-2" v-if="displayType == 'pie'">
        <b-select size="width:100px" v-model="displayPieSelected"
                  @change="chageChartData()">
          <b-form-select-option value="pie">{{ $t('message.budget_pie_chart_select') }}</b-form-select-option>
          <b-form-select-option value="polarArea">{{ $t('message.budget_polar_chart_select') }}</b-form-select-option>
        </b-select>
      </div>


    </div>

    <div v-if="displayType == 'bar'">
      <apexchart
          :key="apexChartKey"
          height="350"
          type="bar"
          :options="chartOptions"
          :series="series"
      ></apexchart>
    </div>
    <div v-if="displayType == 'pie'">

      <div class="row">
        <div class="col-lg-6 text-center">
          <h4 class="f-w-500 mb-4 mt-4 f-20">{{ $t('message.budget_pie_by_category') }}</h4>
          <apexchart
              :key="apexChartKey"
              height="350"
              :type="displayPieSelected"
              :options="pieSumOptions"
              :series="pieCategoryDataArray"
          ></apexchart>
        </div>
        <div class="col-lg-6 text-center">
          <h4 class="f-w-500 mb-4 mt-4 f-20">{{ $t('message.budget_pie_by_item') }}</h4>
          <apexchart
              :key="apexChartKey"
              height="350"
              :type="displayPieSelected"
              :options="pieOptions"
              :series="pieData"
          ></apexchart>
        </div>
      </div>


    </div>


    <div class="row m-b-30" v-if="showItems">
      <div class="col-sm-6"></div>
      <div class="col-sm-6 create-project-btn">
        <div class="text-right">
          <div class="form-group mb-0 mr-0"></div>
          <!-- <a class="btn btn-primary" href="">
            <i data-feather="plus-square"> </i>Create New Project</a
          > -->
          <b-button @click="openFinanceItemModal" variant="primary"><i
              data-feather="plus-square"> </i>{{ $t('message.budget_create_new') }}
          </b-button>
        </div>
      </div>
    </div>
    <div class="responsive-tbl" v-if="showItems">
      <div class="item">
        <div class="table-responsive product-list">

          <div class="mb-2" v-for="group in groups" :key="group.name" v-if="group.items.length">
            <h5 style="background-color: rgba(115, 102, 255, 0.06);padding: 15px 17px;border-radius: 10px;"
                class="mb-4">{{ group.name == 'Uncategorized' ? $t('message.budget_uncategorized') : group.name }}</h5>
            <div style="padding: 0 20px">
              <table class="table table-bordernone table-striped m-b-30">
                <thead>
                <tr>
                  <th></th>
                  <th>{{ $t('message.budget_finance_item') }}</th>
                  <th class="text-center">{{ $t('message.budget_finance_type') }}</th>
                  <th class="text-center">{{ $t('message.budget_finance_start_date') }}</th>
                  <th class="text-center">{{ $t('message.budget_finance_end_date') }}</th>
                  <th class="text-center">{{ $t('message.budget_finance_end_amount') }}</th>
                  <th class="text-center">{{ $t('message.budget_finance_end_period') }}</th>
                  <th class="text-center"></th>
                </tr>

                </thead>
                <tbody>
                <tr v-for="(record, index) in group.items" :key="record.id">
                  <td style="vertical-align: middle;text-align: center;font-weight: bold">{{ index + 1 }}.</td>
                  <td style="vertical-align: middle">
                    <div class="d-inline-block align-middle">
                      <div class="d-inline-block"><span>{{ record.name }}</span></div>
                    </div>
                  </td>
                  <td style="vertical-align: middle" class="text-center">
                    {{ record.type == 'One-time' ? $t('message.budget_one_time') : $t('message.budget_recurring') }}
                  </td>
                  <td style="vertical-align: middle" class="text-center">{{
                      moment(record.start).format("MMM YY")
                    }}
                  </td>
                  <td style="vertical-align: middle" class="text-center">{{
                      record.type == 'One-time' ? '-' : moment(record.end).format("MMM YY")
                    }}
                  </td>
                  <td style="vertical-align: middle" class="text-center">&#8364;{{ record.amount }}</td>
                  <td style="vertical-align: middle" class="text-center">
                    {{ record.type == 'One-time' ? '-' : $t('message.budget_month') }}
                  </td>
                  <td style="vertical-align: middle" class="text-center">

                    <div>
                      <b-button size="xs" variant="primary" class="mb-2" @click="editItem(record)"><i class="fa fa-edit"
                                                                                                      aria-hidden="true"></i>
                      </b-button>
                    </div>
                    <b-button size="xs" variant="danger" @click="deleteItem(record)"><i class="fa fa-trash-o"
                                                                                        aria-hidden="true"></i>
                    </b-button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import ConfirmModal from "../Shared/ConfirmModal";

export default {
  name: "BudgetSection",
  props: {
    showItems: {
      default: true,
      type: Boolean
    },
    cat: {
      default: function () {
        return {}
      },
      type: Object
    },
    budget: {
      default: function () {
        return {}
      },
      type: Object
    },
    color: {
      default: '',
      type: String
    },
    steps: {
      default: function () {
        return []
      },
      type: Array
    },
    token: {
      default: '',
      type: null
    }
  },
  components: {ConfirmModal},
  data() {
    return {
      dataSum: {},
      original_labels: [],
      break_even: '-',
      total_expenses: null,

      apexChartKey: Math.random(),
      displaySelected: 'lines',
      displayPieSelected: 'pie',
      pieGroup: 'category',
      displayType: 'bar',
      chartData: [],
      series: [],

      pieOptions: {
        labels: [],
        legend: {
          show: false
        }
      },
      pieSumOptions: {
        labels: [],
        legend: {
          show: false
        }
      },
      pieData: [],
      pieCategoryDataArray: [],
      chartOptions: {
        chart: {
          stacked: false,
          type: 'line',
          height: 350,
          animations: {
            enabled: false
          }
        },

        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          },
        },
        dataLabels: {
          style: {
            fontSize: '10px',
            colors: ['#333'],
            fontWeight: 'bold',
          },

          enabled: false
        },
        stroke: {
          show: true,
          width: 4,
          curve: 'smooth'
        },
        xaxis: {
          categories: [],
          labels: {
            rotate: -45,
            rotateAlways: true,
            offsetY: 5,
            formatter: (value) => {

              let label = value
              if (value) {
                label = this.moment(value).locale(this.locale).format('MMM, YY')
              }

              return label;
            }
          }
        },
        yaxis: {
          title: {
            text: this.$t('message.budget_amount')
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          x: {
            formatter: function (value, {series, seriesIndex, dataPointIndex}) {

              let count = 0
              series.forEach(item => {
                count += item[dataPointIndex] == null ? 0 : item[dataPointIndex]
              })

              return 'Total: €' + count.toFixed(2)
            }
          }
        }
      },
    }
  },
  async created() {
    this.initData();
  },
  methods: {

    deleteFromDatabase(record) {
      this.removeItemFromDatabase(record.id)
    },

    async initData() {
      this.chartOptions.xaxis.categories = this.buildMonthsPeriod()
      this.original_labels = [...this.chartOptions.xaxis.categories]

      let categories = this.budget.categories

      let expenses = categories.find((item) => {
        return item.name == "Expenses"
      })

      let revenue = categories.find((item) => {
        return item.name == "Revenue"
      })

      let capital = categories.find((item) => {
        return item.name == "Capital"
      })

      let expensesRes = await this.loadSection(expenses.id)
      let expData = this.rebuildData(expensesRes, this.original_labels.length)
      let expDataArray = this.convertObjectToArray(expData)

      let revenueRes = await this.loadSection(revenue.id)
      let revData = this.rebuildData(revenueRes, this.original_labels.length)
      let revDataArray = this.convertObjectToArray(revData)


      let capitalRes = await this.loadSection(capital.id)
      let capData = this.rebuildData(capitalRes, this.original_labels.length)
      let capDataArray = this.convertObjectToArray(capData)


      let data = null

      if (this.cat.id == expenses.id) {
        data = expDataArray
      } else if (this.cat.id == revenue.id) {
        data = revDataArray
      } else {
        data = capDataArray
      }

      this.fillChart(data)
      this.calculateTotal(data)
      this.calculateBreakEven(expDataArray, revDataArray, capDataArray)
    },

    findFirstPositiveIndex(array) {
      for (let i = 0; i < array.length; i++) {
        if (array[i] > 0) {
          return i;
        }
      }
      return null;
    },

    calculateBreakEven(expDataArray, revDataArray, capDataArray) {

      let expSum = Array(expDataArray.length).fill(0)
      let revSum = Array(expDataArray.length).fill(0)
      let capSum = Array(expDataArray.length).fill(0)

      expDataArray.forEach((item) => {
        for (let i = 0; i < item.data.length; i++) {
          expSum[i] += item.data[i]
        }
      })

      revDataArray.forEach((item) => {
        for (let i = 0; i < item.data.length; i++) {
          revSum[i] += item.data[i]
        }
      })

      capDataArray.forEach((item) => {
        for (let i = 0; i < item.data.length; i++) {
          capSum[i] += item.data[i]
        }
      })

      let netResultArray = []

      for (let i = 0; i < expSum.length; i++) {

        netResultArray[i] = revSum[i] - capSum[i] - expSum[i]

        if (i) {
          netResultArray[i] += netResultArray[i - 1]
        }
      }

      let beLabel = this.original_labels[this.findFirstPositiveIndex(netResultArray)]
      this.break_even = beLabel == null ? this.$t('message.never') : this.moment(beLabel).locale(this.locale).format('MMMM, YYYY');

    },
    calculateTotal(data) {

      if (data.length) {

        let sum = 0
        data.forEach((item) => {
          sum += item.sum
        })

        this.total_expenses = sum
      } else {
        this.total_expenses = 0
      }
    },

    convertObjectToArray(data) {

      let returnArray = [];

      Object.entries(data).forEach(([key, value]) => {

        returnArray.push({
          name: key,
          data: value.data,
          sum: value.data.reduce((a, b) => a + b, 0),
          cluster: value.cluster
        })
      })

      return returnArray;
    },

    rebuildData(request, labelsLength) {

      let formattedRecords = []
      let rate = request.result[0].name == 'Expenses' ? this.budget['burn_rate'] : this.budget['earn_rate'];

      let records = request.result[0].records


      records.forEach((record) => {

        let newRecord = {
          name: record.name,
          values: Array(labelsLength).fill(0),

        }

        let type = record.type

        if (type == 'One-time') {

          let label = this.moment(record.start).format('YYYY-MM');
          let index = this.original_labels.indexOf(label)

          if (index != -1) {
            newRecord.values[index] = +parseFloat(record.amount).toFixed(2)
          }

        } else {

          let start = this.moment(record.start).format('YYYY-MM');
          let end = this.moment(record.end).format('YYYY-MM');

          let startIndex = this.original_labels.indexOf(start)
          let endIndex = this.original_labels.indexOf(end)

          //Check earn or burn rate
          let recordsBetweenIndexes = endIndex - startIndex

          if (recordsBetweenIndexes == 0) {
            newRecord.values[startIndex] = +parseFloat(record.amount).toFixed(2)
          } else {

            for (let i = 0; i <= recordsBetweenIndexes; i++) {

              let amount = 0
              if (i == 0 || this.budget[rate] == 0) {
                amount = +parseFloat(record.amount).toFixed(2)
              } else {
                amount = parseFloat(newRecord.values[startIndex + i - 1]) + ((parseFloat(newRecord.values[startIndex + i - 1]) * rate) / 100)
              }

              newRecord.values[startIndex + i] = +amount.toFixed(2)
            }
          }
        }

        newRecord.cluster = record.cluster
        formattedRecords.push(newRecord)

      })

      let formattedObject = {}

      formattedRecords.forEach((item) => {

        if (formattedObject[item.name]) {

          for (let i = 0; i < item.values.length; i++) {
            formattedObject[item.name].data[i] += item.values[i]
          }

        } else {
          formattedObject[item.name] = {data: item.values, cluster: item.cluster}
        }

      })

      return formattedObject
    },
    fillChart(seriesArray) {

      if (seriesArray.length) {

        let labelArray = null
        labelArray = new Array(seriesArray[0].data.length).fill(0);

        seriesArray.forEach((item) => {

          let tempArray = item.data;

          tempArray.forEach((record, index) => {
            labelArray[index] = labelArray[index] + record
          })

        })
      }

      seriesArray.forEach((item) => {

        item.data.forEach((record, index) => {
          item.data[index] = record == 0 ? null : parseFloat(record.toFixed(2))
        })
      })

      this.chartData = seriesArray

      this.series = seriesArray

      let pieData = []
      let pieLabels = []

      let pieCategoryObject = {}
      let pieCategoryDataArray = []
      let pieCategoryLabelsArray = []

      seriesArray.forEach((item) => {

        let sum = item.data.reduce((partialSum, a) => partialSum + a, 0);

        item.cluster = item.cluster == null ? this.$t('message.budget_uncategorized') : item.cluster

        if (pieCategoryObject[item.cluster]) {
          pieCategoryObject[item.cluster] += sum
        } else {
          pieCategoryObject[item.cluster] = sum
        }

        pieData.push(sum)
        pieLabels.push(item.name)
      })

      Object.entries(pieCategoryObject).forEach(([key, value]) => {
        pieCategoryDataArray.push(parseFloat(value.toFixed(2)))
        pieCategoryLabelsArray.push(key)
      })

      this.pieCategoryDataArray = pieCategoryDataArray
      this.pieSumOptions.labels = pieCategoryLabelsArray

      let recordArray = []
      pieData.forEach((item) => {
        recordArray.push(parseFloat(item.toFixed(2)))
      })

      this.pieData = recordArray
      this.pieOptions.labels = pieLabels
    },

    async removeItemFromDatabase(itemId) {

      await this.$store.dispatch('budget/deleteItem', itemId)

      this.cat.records = this.cat.records.filter((item) => {
        return item.id != itemId
      })

      this.initData()
    },
    editItem(item) {
      this.$emit('openFinanceItemModal', this.cat, item, this.getAutoSuggests())
    },
    deleteItem(item) {
      this.$refs['budgetItemRemove'].openModal(item, this.$t('message.delete_item_modal_title'), this.$t('message.delete_this_record'), this.$t('message.are_you_sure'))
    },

    chageChartData() {

      switch (this.displaySelected) {
        case 'lines':
          this.chartOptions.chart.stacked = false
          break;
        case 'stacked':
          this.chartOptions.chart.stacked = true
          break;
        case 'sum':
          this.chartOptions.chart.stacked = false
          break;
      }

      this.apexChartKey = Math.random()
    },

    async loadSection(catId) {
      this.total_expenses = 0
      return await this.$store.dispatch('budget/loadSection', {id: catId, token: this.token})
    },

    buildMonthsPeriod() {

      let dateStart = this.moment(this.budget.start)
      let dateEnd = this.moment(this.budget.end)
      let timeValues = [];

      while (dateEnd > dateStart || dateStart.format('M') === dateEnd.format('M')) {
        timeValues.push(dateStart.format('YYYY-MM'));
        dateStart.add(1, 'month');
      }

      return timeValues
    },
    openFinanceItemModal() {

      this.$emit('openFinanceItemModal', this.cat, null, this.getAutoSuggests())
    },
    getAutoSuggests: function () {
      if (!this.cat || !this.cat.records.length) {
        return []
      }

      let records = this.cat.records.filter((item) => {
        return item.cluster != null && item.cluster != 'Uncategorized'
      })

      return [...new Set(records.map(a => a.cluster))]
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters['shared/isLoading']
    },
    locale: function () {
      return this.$i18n.locale
    },
    groups: function () {

      if (!this.cat || !this.cat.records.length) {
        return []
      }

      let groups = [{
        name: 'Uncategorized',
        items: []
      }]

      let objectsGroups = []

      this.cat.records.forEach((item) => {

        if (item.cluster) {

          let exist = objectsGroups.find((record) => {
            return record.name == item.cluster
          })

          if (exist) {
            exist.items.push(item)
          } else {

            objectsGroups.push({
              name: item.cluster,
              items: [item]
            })
          }

        } else {
          groups[0].items.push(item)
        }
      })

      objectsGroups.sort((a, b) => (a.name > b.name) ? 1 : -1)
      objectsGroups.push(groups[0])

      return objectsGroups
    }
  }
};

</script>